import _ from 'lodash';

const SingleDiscussionPageCtrl = ['$scope', 'DiscussionService', 'FeedStore', 'user', ($scope, DiscussionService, FeedStore, user) => {
  const fetchDiscussions = _.bind(DiscussionService.feed, DiscussionService);
  $scope.discussions = FeedStore.create(fetchDiscussions, { filter: { commented_on: user.id }, sort: '-commented_on_at' });
  $scope.discussions.load();
}];

export default SingleDiscussionPageCtrl;
